import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { usePostPage } from "../PostPageContext";
import PostPageLabelsLabel from "./PostPageLabelsLabel";
const PostPageLabels = (props)=>{
    const { labels , rootURL , alterLabelsForItems  } = props;
    const { authorized  } = usePostPage();
    const handleRemove = useMemo(()=>{
        if (!authorized) return undefined;
        return (label)=>{
            alterLabelsForItems({
                variables: {
                    addLabelIds: [],
                    removeLabelIds: [
                        label.id
                    ]
                }
            });
        };
    }, [
        alterLabelsForItems,
        authorized
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: labels.map((label)=>/*#__PURE__*/ _jsx(PostPageLabelsLabel, {
                rootURL: rootURL,
                label: label,
                onClick: handleRemove
            }, label.nodeId))
    });
};
export default PostPageLabels;
